module.exports = __webpack_public_path__ + "media/stylesheets/fonts/fontawesome/fa-brands-400-088a34f78f530102fd9661173b4a4f26.eot";